import styled, { a2bTheme } from '../../../../../theme/styled';

interface StyledProps {
  theme: a2bTheme;
}

const OrderCardContainer = styled.div`
  box-sizing: border-box;
  font-family: ${({ theme }: StyledProps) => theme.fonts.primary};
  background: ${({ theme }: StyledProps) => theme.colors.bgPrimary};
  padding: 16px;
`;

const OrderBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const ActionsBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
`;

export default {
  OrderCardContainer,
  OrderBlock,
  ActionsBlock,
};
